import React, { useState } from 'react'

import { BulletList, BulletListType, ModalVariant } from '@at/design-system-patterns'
import { InfoBanner } from '../../components/info-banner/info-banner'
import { PortalComponent } from '../../components/modals/portal'
import {
    StyledFinanceModalContent,
    FinanceModalParagraph,
    FinanceModalTitle,
    StyledAcceptButton,
    StyledAccordionList,
    StyledInfoModal,
} from '../../components/search-listing-details/search-listing-details.styles'
import { InfoButton } from '../../components/info-banner/info-banner.styles'
import { useATTrackInteraction } from '@at/consumer-web-snowplow'

import {
    HELP_TEXT_TEXT_STATIC_COPY,
    HELP_TEXT_LINK_STATIC_COPY,
    FINANCE_LEARN_MORE_0_PCP_TITLE_STATIC_COPY,
    FINANCE_LEARN_MORE_0_PCP_BODY_WHAT_IS_PCP_BODY_STATIC_COPY,
    FINANCE_LEARN_MORE_0_PCP_BODY_LEARN_MORE_PCP_STEPS_BODY_0_STATIC_COPY,
    FINANCE_LEARN_MORE_0_PCP_BODY_LEARN_MORE_PCP_STEPS_BODY_1_STATIC_COPY,
    FINANCE_LEARN_MORE_0_PCP_BODY_LEARN_MORE_PCP_STEPS_BODY_2_STATIC_COPY,
    FINANCE_LEARN_MORE_0_PCP_BODY_PCP_MILEAGE_LIMIT_BODY_STATIC_COPY,
    FINANCE_LEARN_MORE_2_HP_BODY_0_STATIC_COPY,
    FINANCE_LEARN_MORE_2_HP_BODY_1_STATIC_COPY,
    FINANCE_LEARN_MORE_2_HP_BODY_2_STATIC_COPY,
    FINANCE_LEARN_MORE_2_HP_BODY_3_STATIC_COPY,
    FINANCE_LEARN_MORE_2_HP_TITLE_STATIC_COPY,
    FINANCE_LEARN_MORE_3_CS_BODY_0_STATIC_COPY,
    FINANCE_LEARN_MORE_3_CS_BODY_1_STATIC_COPY,
    FINANCE_LEARN_MORE_3_CS_BODY_2_STATIC_COPY,
    FINANCE_LEARN_MORE_3_CS_BODY_3_STATIC_COPY,
    FINANCE_LEARN_MORE_3_CS_TITLE_STATIC_COPY,
    FINANCE_LEARN_MORE_4_LEASING_BODY_CONSIDERATIONS_CONSIDERATION_POINTS_0_STATIC_COPY,
    FINANCE_LEARN_MORE_4_LEASING_BODY_CONSIDERATIONS_CONSIDERATION_POINTS_1_STATIC_COPY,
    FINANCE_LEARN_MORE_4_LEASING_BODY_CONSIDERATIONS_CONSIDERATION_POINTS_2_STATIC_COPY,
    FINANCE_LEARN_MORE_4_LEASING_BODY_CONSIDERATIONS_INTRO_STATIC_COPY,
    FINANCE_LEARN_MORE_4_LEASING_BODY_HOW_LEASING_WORKS_STATIC_COPY,
    FINANCE_LEARN_MORE_4_LEASING_BODY_LEASING_TERMS_STATIC_COPY,
    FINANCE_LEARN_MORE_4_LEASING_TITLE_STATIC_COPY,
    FINANCE_LEARN_MORE_5_INTRODUCTION_TITLE_STATIC_COPY,
    FINANCE_LEARN_MORE_5_INTRODUCTION_BODY_FINANCE_TYPE_STATIC_COPY,
    FINANCE_LEARN_MORE_5_INTRODUCTION_BODY_EXPLANATION_STATIC_COPY,
    HELP_TEXT_TEXT_EXCLUDING_LEASING_STATIC_COPY,
    FINANCE_LEARN_MORE_5_INTRODUCTION_BODY_FINANCE_TYPE_EXCLUDING_LEASING_STATIC_COPY,
} from '@at/consumer-ui-text/lib/finance//shared/finance.shared.learn-more'
import { useChannel } from '../../hooks/use-abtest.hook'
import { Channel } from '@at/consumer-web-types'

export const FlexibleFinanceFilterInfoBanner = () => {
    const [showModal, setShowModal] = useState(false)
    const handleFinanceLearnMoreModalInteraction = useATTrackInteraction({
        trackingLabel: 'finance-learn-more-info-button',
    })

    const channel = useChannel()

    const financeContent = [
        {
            rowHeading: FINANCE_LEARN_MORE_0_PCP_TITLE_STATIC_COPY,
            rowContent: (
                <FinanceModalParagraph as="p">
                    {FINANCE_LEARN_MORE_0_PCP_BODY_WHAT_IS_PCP_BODY_STATIC_COPY}
                    <BulletList
                        items={[
                            FINANCE_LEARN_MORE_0_PCP_BODY_LEARN_MORE_PCP_STEPS_BODY_0_STATIC_COPY,
                            FINANCE_LEARN_MORE_0_PCP_BODY_LEARN_MORE_PCP_STEPS_BODY_1_STATIC_COPY,
                            FINANCE_LEARN_MORE_0_PCP_BODY_LEARN_MORE_PCP_STEPS_BODY_2_STATIC_COPY,
                        ]}
                        listType={BulletListType.STANDARD}
                    />
                    {FINANCE_LEARN_MORE_0_PCP_BODY_PCP_MILEAGE_LIMIT_BODY_STATIC_COPY}
                </FinanceModalParagraph>
            ),
        },
        {
            rowHeading: FINANCE_LEARN_MORE_2_HP_TITLE_STATIC_COPY,
            rowContent: (
                <>
                    <FinanceModalParagraph as="p">{FINANCE_LEARN_MORE_2_HP_BODY_0_STATIC_COPY}</FinanceModalParagraph>
                    <FinanceModalParagraph as="p">{FINANCE_LEARN_MORE_2_HP_BODY_1_STATIC_COPY}</FinanceModalParagraph>
                    <FinanceModalParagraph as="p">{FINANCE_LEARN_MORE_2_HP_BODY_2_STATIC_COPY}</FinanceModalParagraph>
                    <FinanceModalParagraph as="p">{FINANCE_LEARN_MORE_2_HP_BODY_3_STATIC_COPY}</FinanceModalParagraph>
                </>
            ),
        },
        {
            rowHeading: FINANCE_LEARN_MORE_3_CS_TITLE_STATIC_COPY,
            rowContent: (
                <>
                    <FinanceModalParagraph as="p">{FINANCE_LEARN_MORE_3_CS_BODY_0_STATIC_COPY}</FinanceModalParagraph>
                    <FinanceModalParagraph as="p">{FINANCE_LEARN_MORE_3_CS_BODY_1_STATIC_COPY}</FinanceModalParagraph>
                    <FinanceModalParagraph as="p">{FINANCE_LEARN_MORE_3_CS_BODY_2_STATIC_COPY}</FinanceModalParagraph>
                    <FinanceModalParagraph as="p">{FINANCE_LEARN_MORE_3_CS_BODY_3_STATIC_COPY}</FinanceModalParagraph>
                </>
            ),
        },
    ]

    if (channel !== Channel.bikes) {
        financeContent.push({
            rowHeading: FINANCE_LEARN_MORE_4_LEASING_TITLE_STATIC_COPY,
            rowContent: (
                <>
                    <FinanceModalParagraph as="p">
                        {FINANCE_LEARN_MORE_4_LEASING_BODY_HOW_LEASING_WORKS_STATIC_COPY}
                    </FinanceModalParagraph>
                    <FinanceModalParagraph as="p">
                        {FINANCE_LEARN_MORE_4_LEASING_BODY_LEASING_TERMS_STATIC_COPY}
                    </FinanceModalParagraph>
                    <FinanceModalParagraph as="p">
                        {FINANCE_LEARN_MORE_4_LEASING_BODY_CONSIDERATIONS_INTRO_STATIC_COPY}
                        <BulletList
                            items={[
                                FINANCE_LEARN_MORE_4_LEASING_BODY_CONSIDERATIONS_CONSIDERATION_POINTS_0_STATIC_COPY,
                                FINANCE_LEARN_MORE_4_LEASING_BODY_CONSIDERATIONS_CONSIDERATION_POINTS_1_STATIC_COPY,
                                FINANCE_LEARN_MORE_4_LEASING_BODY_CONSIDERATIONS_CONSIDERATION_POINTS_2_STATIC_COPY,
                            ]}
                            listType={BulletListType.STANDARD}
                        />
                    </FinanceModalParagraph>
                </>
            ),
        })
    }

    const helpText =
        channel !== Channel.bikes ? [HELP_TEXT_TEXT_STATIC_COPY] : [HELP_TEXT_TEXT_EXCLUDING_LEASING_STATIC_COPY]

    const financeTypeText =
        channel !== Channel.bikes
            ? FINANCE_LEARN_MORE_5_INTRODUCTION_BODY_FINANCE_TYPE_STATIC_COPY
            : FINANCE_LEARN_MORE_5_INTRODUCTION_BODY_FINANCE_TYPE_EXCLUDING_LEASING_STATIC_COPY

    return (
        <>
            <InfoBanner paragraphs={helpText}>
                <InfoButton
                    className="info-button"
                    text={HELP_TEXT_LINK_STATIC_COPY}
                    displayType="tertiary"
                    underline={true}
                    onClick={() => {
                        setShowModal(true)
                    }}
                    trackingCallback={handleFinanceLearnMoreModalInteraction}
                />
                {showModal && (
                    <PortalComponent show={showModal}>
                        <StyledInfoModal
                            isShowing={true}
                            closeText={'Back'}
                            hideFn={() => {
                                setShowModal(false)
                            }}
                            variation={ModalVariant.SLIDE}
                            hasBackLink={false}
                            modalTitle={FINANCE_LEARN_MORE_5_INTRODUCTION_TITLE_STATIC_COPY}
                            focusId="modal-button"
                            modalHashName="different-finance-types"
                            className="info-modal"
                        >
                            <StyledFinanceModalContent>
                                <FinanceModalTitle as="h1">
                                    {FINANCE_LEARN_MORE_5_INTRODUCTION_TITLE_STATIC_COPY}
                                </FinanceModalTitle>
                                <FinanceModalParagraph as="p">{financeTypeText}</FinanceModalParagraph>
                                <FinanceModalParagraph as="p">
                                    {FINANCE_LEARN_MORE_5_INTRODUCTION_BODY_EXPLANATION_STATIC_COPY}
                                </FinanceModalParagraph>
                                <StyledAccordionList items={financeContent} />
                                <StyledAcceptButton
                                    text="OK, got it"
                                    onClick={() => {
                                        setShowModal(false)
                                    }}
                                />
                            </StyledFinanceModalContent>
                        </StyledInfoModal>
                    </PortalComponent>
                )}
            </InfoBanner>
        </>
    )
}
